import React, { useState } from 'react';
import { Modal, Input, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { TextArea } = Input;

const RejectClaimModal = ({ isOpen, onClose, onSubmit, submitting }) => {
  const [rejectReason, setRejectReason] = useState('');
  const [rejectNotes, setRejectNotes] = useState('');

  const handleSubmit = () => {
    onSubmit(rejectReason, rejectNotes);
    // Campos se reinician en handleClose para que no se borren en caso de error
  };

  const handleClose = () => {
    setRejectReason('');
    setRejectNotes('');
    onClose();
  };

  return (
    <Modal
      title={null}
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      className="claim-reject-modal"
      width={500}
    >
      <div className="claim-reject-modal-header">
        <h2>Solicitar Corrección</h2>
        <p>Indica el motivo por el cual la información debe ser corregida.</p>
      </div>
      
      <div className="claim-reject-modal-body">
        <div className="form-group">
          <label>Motivo de la corrección <span style={{color: '#ef4444'}}>*</span></label>
          <TextArea 
            rows={4}
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
            placeholder="Describe el motivo de la corrección de manera clara y específica..."
            maxLength={500}
            className="claim-textarea"
          />
          <div className="claim-char-count">{rejectReason.length} / 500 caracteres</div>
        </div>
        
        <div className="form-group" style={{ marginTop: '20px' }}>
          <label>Observaciones adicionales <span>(opcional)</span></label>
          <TextArea 
            rows={3}
            value={rejectNotes}
            onChange={(e) => setRejectNotes(e.target.value)}
            placeholder="Agrega observaciones adicionales que ayuden al participante a entender la corrección solicitada..."
            maxLength={500}
            className="claim-textarea"
          />
          <div className="claim-char-count">{rejectNotes.length} / 500 caracteres</div>
        </div>
        
        <div className="claim-alert warning" style={{ marginTop: '20px', border: '1px solid #f59e0b' }}>
          <ExclamationCircleOutlined />
          El participante será notificado para que realice las correcciones necesarias en su información.
        </div>
      </div>
      
      <div className="claim-reject-modal-footer">
        <Button 
          className="btn-cancel" 
          onClick={handleClose}
          disabled={submitting}
        >
          Cancelar
        </Button>
        <Button 
          className="btn-submit-reject" 
          onClick={handleSubmit}
          loading={submitting}
          disabled={!rejectReason.trim()}
        >
          Enviar Solicitud de Corrección
        </Button>
      </div>
    </Modal>
  );
};

export default RejectClaimModal;
